// Template231: Kuala Lumpur - Consejos útiles (Tips.jsx)
// Header, intro, list of tips from data.tips (icon + text), sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template231 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";
	const tips = Array.isArray(page?.data?.tips)
		? page.data.tips
		: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
				}}
			>
				{tips.map((tip, idx) => (
					<Box
						key={idx}
						data-block-id={`text-${idx + 3}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #dee7e3",
							...(idx === tips.length - 1 && {
								width: isSmallScreen ? "100%" : "80%",
							}),
						}}
					>
						<Box component="span" sx={{ fontSize: 18 }}>
							{tip.icono}
						</Box>
						<Box component="span" sx={{ fontSize: 13, color: contentColor }}>
							{tip.texto}
						</Box>
					</Box>
				))}

				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -60 : 0,
							right: -20,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template231.thumbnail = "/images/template-1.png";
export default Template231;
